export const ERP_THEME_VALUES = {
  colors: {
    primary: '#ee3741',
    primaryHover: '#f25f67',
    primaryActive: '#c92f37',
    secondary: '#23b27c',
    buttonPrimaryHover: '#45bf8c',
    secondaryHover: '#1f9e6f',
    secondaryActive: '#1b8b62',
    error: '#ee3741',
    borderLight: '#c1c0c0',
    disabledBg: '#e1e1e1',
    disabledText: '#000',
    lightBlue: '#ebf2fc',
    lightGray: '#f9f9f9',
    menuActiveBg: 'hsla(0, 100%, 79%, .22)',
  },
  radius: {
    base: 10,
    small: 10,
    buttonSmall: 5,
    panel: 15,
    table: 15,
    checkbox: 0,
  },
  steps: {
    iconSize: 32,
    iconFontSize: 14,
    customIconSize: 32,
    customIconFontSize: 16,
    customIconTop: 0,
    iconTop: -0.5,
  },
};
